import { render, staticRenderFns } from "./RemunerationTypes.vue?vue&type=template&id=2cf235a8&"
import script from "./RemunerationTypes.vue?vue&type=script&lang=js&"
export * from "./RemunerationTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports